import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.4, delay, ease: [0.22, 1, 0.36, 1] },
});

const profiles = [
  {
    name: 'GitHub',
    handle: 'Krishna41357',
    role: 'Source code, projects & open source contributions',
    url: 'https://github.com/Krishna41357',
    initials: 'GH',
    color: '#171515',
    meta: 'Open Source · 10+ repos',
  },
  {
    name: 'LeetCode',
    handle: 'Krishna_Srivastava11244',
    role: 'Data structures, algorithms & competitive problem solving',
    url: 'https://leetcode.com/u/Krishna_Srivastava11244/',
    initials: 'LC',
    color: '#f89f1b',
    meta: 'DSA Practice',
  },
  {
    name: 'LinkedIn',
    handle: 'Krishna Srivastava',
    role: 'Professional network, work history & recommendations',
    url: 'https://linkedin.com/in/krishna-srivastava-a84b65299',
    initials: 'LI',
    color: '#0a66c2',
    meta: 'Professional Profile',
  },
  {
    name: 'Twitter / X',
    handle: '@Krishna91135239',
    role: 'Thoughts on tech, building in public, and dev life',
    url: 'https://x.com/Krishna91135239',
    initials: 'X',
    color: '#000000',
    meta: 'Building in public',
  },
];

export default function DsaStatus() {
  return (
    <section id="profiles" className="relative w-full overflow-hidden bg-transparent py-8 lg:py-10">
      <div className="relative z-10 max-w-3xl mx-auto px-6 sm:px-10 lg:px-14">

        {/* Header */}
        <div className="flex items-end justify-between mb-6">
          <div>
            <motion.p {...fadeUp(0)} className="font-mono text-[10px] uppercase tracking-[0.2em] text-purple-600 font-bold mb-1">
              &lt;/Profiles&gt;
            </motion.p>
            <motion.h1 {...fadeUp(0.04)} className="text-2xl sm:text-3xl font-black text-black">
              Find me online
            </motion.h1>
          </div>
          <motion.div {...fadeUp(0.08)} className="pb-0.5 text-right">
            <span className="text-lg font-black text-black leading-none block">{profiles.length}</span>
            <span className="text-[9px] font-mono text-black/30 uppercase tracking-wider mt-0.5 block">platforms</span>
          </motion.div>
        </div>

        <motion.div {...fadeUp(0.1)} className="h-px bg-black/10 mb-0" />

        {/* Rows */}
        <div>
          {profiles.map((p, i) => (
            <motion.a
              key={p.name}
              href={p.url}
              target="_blank"
              rel="noreferrer"
              {...fadeUp(0.1 + i * 0.06)}
              className="group flex items-center gap-4 py-4 border-b border-black/8 last:border-0 hover:bg-black/[0.015] transition-colors duration-150 px-1 -mx-1 rounded-sm"
            >
              {/* Avatar */}
              <div
                className="w-9 h-9 rounded-xl flex items-center justify-center text-white text-[11px] font-black shrink-0 shadow-[2px_2px_0px_0px_rgba(0,0,0,0.15)]"
                style={{ background: p.color }}
              >
                {p.initials}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="text-[13px] font-black text-black">{p.name}</span>
                  <span className="text-[10px] font-mono text-black/30">{p.handle}</span>
                </div>
                <p className="text-[11px] text-black/40 font-mono truncate">{p.role}</p>
              </div>

              {/* Meta */}
              <span className="hidden sm:block text-[10px] font-mono text-black/30 shrink-0">{p.meta}</span>

              <ArrowRight
                size={13}
                className="shrink-0 text-black/20 group-hover:text-purple-500 group-hover:translate-x-1 transition-all duration-150"
              />
            </motion.a>
          ))}
        </div>

      </div>
    </section>
  );
}